<template>
    <div class="container px-0">
        <div class="row" v-if="loading">
            <div class="col-12">
				<loader></loader>
            </div>
        </div>

        <div class="row" v-else-if="issues.length">
            <div class="col-12">
                <div class="flex-table">
                    <list-item
                        v-for="(issue, index) in issues"
                        :key="index"
                        :active="issue.tag === 'Unresolved'"
                        @click="loadIssue(issue)"
                    >
                        <template slot="title">
                            <div class="">
                                <h5 class="mb-0 text-dark font-weight-bold">{{issue.title}}</h5>
                                <h6 class="mb-0 text-dark font-weight-normal">{{issue.resolution}}</h6>
                                <h6 class="text-danger font-weight-normal">{{issue.date_of_issue}}</h6>
                            </div>
                        </template>
                        <template slot="center">
                            <div class="badge badge--sm badge--negative">{{issue.tag}}</div>
                        </template>
                    </list-item>
                </div>
            </div>
        </div>
        <div class="form-submission-card" v-else>
            <div class="form-submission-card-content" >
                <h5>No issues or concerns</h5>
            </div>
        </div>
    </div>
</template>

<script>
	import ListItem from "../ListComponent/ListItem";
	import Loader from "../general_components/Loader";
    export default {
		name: "JobIssuesAndConcernsComponent",
        components: {Loader, ListItem},
        props: [
            'load_url',
            'show_submission_url'
        ],

        data(){
		    return {
		        loading: false,
                issues: [],
            }
        },

        mounted() {
            this.load();
        },

        methods: {
            load(){
                let _this = this;
                if (_this.loading){
                    return;
                }

                _this.loading = true;

                axios.get(_this.load_url)
                    .then(function (response){
                        _this.issues = response.data;
                        _this.loading = false;
                    });
            },

            loadIssue(issue){
            	if (issue.tag === 'Unresolved'){
					window.location.href = this.show_submission_url.replace('?', issue.id);
				}
            }
        }
	}
</script>
